// extracted by mini-css-extract-plugin
module.exports = {"eventWrapper":"EventsCarousel_eventWrapper__XFvnV","root":"EventsCarousel_root__FPAuL","header":"EventsCarousel_header__Gk4gw","visibleSlide":"EventsCarousel_visibleSlide__2XlSx"};